// Map an SR/OV couple vraisemblance ('faible'|'moyenne'|'forte') to a 1-4 level.
// Defaults to 2 (vraisemblable) when the couple is missing — conservative middle ground.
export const COUPLE_VRAISEMBLANCE_MAP = {
  faible: 1,
  moyenne: 2,
  forte: 3,
};

export function vraisemblanceFromCouple(couple) {
  if (!couple || !couple.vraisemblance) return 2;
  return COUPLE_VRAISEMBLANCE_MAP[couple.vraisemblance] || 2;
}

// Proposed likelihood for a preliminary path: max of the couple suggestion and path niveau.
// When no couple exists, fall back to path niveau directly (no artificial floor at 2).
export function getProposedLikelihood(couple, niveau) {
  const fromCouple = couple ? vraisemblanceFromCouple(couple) : null;
  const hasValidNiveau = Number.isInteger(niveau) && niveau >= 1 && niveau <= 4;
  if (fromCouple === null) return hasValidNiveau ? niveau : 2;
  if (!hasValidNiveau) return fromCouple;
  return Math.max(fromCouple, niveau);
}